import React from "react";

const ProductGridSkeleton = ({
  count = 12,
  cardClass = "col-xl-2 col-lg-3 col-sm-4 col-6",
  bare = false,
  variant = "grid",
}) => {
  const grid = (
    <div
      className={`row gy-4 g-12 product-grid${variant === "row" ? " product-grid--row" : ""}`}
      aria-busy="true"
      aria-label="Loading products"
    >
      {Array.from({ length: count }, (_, i) => (
        <div className={cardClass} key={i}>
          <div className="product-skeleton border border-gray-100 rounded-8 overflow-hidden placeholder-glow">
            <span className="product-skeleton__thumb placeholder d-block w-100 bg-gray-100" />
            <span className="d-block p-10">
              <span className="placeholder d-block col-10 rounded bg-gray-100" />
              <span className="placeholder d-block col-7 mt-8 rounded bg-gray-100" />
              <span className="placeholder d-block col-5 mt-12 rounded bg-gray-100" />
            </span>
          </div>
        </div>
      ))}
    </div>
  );
  return bare ? grid : <div className="container container-lg mt-24">{grid}</div>;
};

export default ProductGridSkeleton;
